import { createContext, useContext } from 'react';

import type { UseTheme } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const context = createContext({} as any);

const useTheme: UseTheme = () => {
    const { setTheme, theme } = useContext(context);

    return {
        context,
        setTheme,
        theme
    };
};

export default useTheme;
